import React, { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: { services: "Services", compare: "Comparatif", faq: "FAQ", marketing: "IA Marketing", quote: "Demande d'offre", booking: "Rendez-vous", contact: "Contact", admin: "Espace perso" },
    hero: {
      badge: "Depuis 2015 · Clients ravis",
      title1: "Le leasing intelligent",
      title2: "pour votre entreprise",
      subtitle: "Courtier indépendant en leasing, renting et location longue durée. Automobile, camions et génie civil — partout en Belgique.",
      cta1: "Demander une offre",
      cta2: "Parler à notre IA",
      stat1: "d'expérience", stat1n: "10+ ans",
      stat2: "de réponse", stat2n: "48h",
      stat3: "couverte", stat3n: "Belgique",
      warning: "Attention, emprunter de l'argent coûte aussi de l'argent.",
    },
    sectors: {
      title: "Nos secteurs d'expertise",
      subtitle: "Une solution de financement adaptée à chaque professionnel.",
      auto: { t: "Automobile", d: "Voitures de société, taxi, secteur HORECA. Les meilleures conditions du marché." },
      truck: { t: "Camions & Transport", d: "Poids lourds et transport routier. Financements sur mesure pour votre flotte." },
      civil: { t: "Génie civil", d: "Machines et engins de chantier. Équipez votre entreprise sans immobiliser votre trésorerie." },
    },
    compare: {
      title: "Leasing, Renting ou LLD ?",
      subtitle: "Comprenez les différences essentielles pour la Belgique.",
      col: { crit: "Critère", leasing: "Leasing", renting: "Renting", lld: "LLD" },
      rows: {
        reg: "Immatriculation",
        balance: "Bilan comptable",
        residual: "Valeur résiduelle",
        end: "Fin de contrat",
        owner: "Propriété",
      },
      vals: {
        regL: "Au nom du CLIENT", regR: "Au nom du CLIENT", regLLD: "Au nom du LEASEUR",
        balL: "Au bilan (amorti)", balR: "Hors bilan (charges)", balLLD: "Hors bilan (charges)",
        resL: "1% à 15% (faible)", resR: "16% à 25%", resLLD: "Pas d'option d'achat",
        endL: "Rachat du véhicule", endR: "Restitution ou rachat", endLLD: "Restitution du véhicule",
        ownL: "Propriétaire économique", ownR: "Le leaseur reste propriétaire", ownLLD: "Le loueur reste propriétaire",
      },
      note: "En résumé : le leasing et le renting sont immatriculés au nom du client (leasing au bilan, renting hors bilan) ; la LLD est immatriculée au nom du leaseur et reste hors bilan.",
    },
    faq: { title: "Questions fréquentes", subtitle: "Tout savoir sur le leasing en Belgique." },
    process: {
      title: "Comment ça marche ?",
      subtitle: "Une réponse en 48h ouvrables dès que votre dossier est complet.",
      steps: [
        { t: "1. Vos documents", d: "Scannez votre bon de commande, votre carte d'identité recto/verso et votre dernier avertissement extrait de rôle." },
        { t: "2. Votre valeur résiduelle", d: "Choisissez votre valeur résiduelle (de 1% à 20%) qui déterminera le montant de rachat en fin de contrat." },
        { t: "3. Envoi sécurisé", d: "Transmettez vos documents via notre formulaire sécurisé conforme RGPD ou par email." },
        { t: "4. Réponse en 48h", d: "Notre équipe dynamique vous répond endéans les 48 heures ouvrables." },
      ],
    },
    marketing: {
      title: "IA Marketing",
      subtitle: "Générez des propositions de posts Facebook & LinkedIn en un clic.",
      platform: "Plateforme", topic: "Sujet du post", topicPh: "Ex : avantages du leasing électrique en 2026",
      tone: "Ton", generate: "Générer les propositions", generating: "Génération...", copy: "Copier", copied: "Copié !",
      empty: "Choisissez une plateforme et un sujet, puis générez 3 propositions prêtes à publier.",
    },
    quote: {
      title: "Demande d'offre",
      subtitle: "Recevez une réponse personnalisée en 48h ouvrables.",
      name: "Nom complet", email: "Email", phone: "Téléphone", company: "Société",
      sector: "Secteur", formula: "Formule souhaitée", vehicle: "Bien à financer", vehiclePh: "Ex : Audi A4, camion Volvo, excavatrice...",
      message: "Message", docs: "Documents (carte d'identité, fiches de salaire, bon de commande)",
      upload: "Cliquez pour ajouter des fichiers (PDF, JPG, PNG)", uploading: "Envoi...",
      gdpr: "J'accepte que I-LEASE SRL traite mes données personnelles et documents financiers (carte d'identité, fiches de salaire) dans le cadre de ma demande, conformément au RGPD.",
      submit: "Envoyer ma demande", submitting: "Envoi...",
      success: "Demande envoyée ! Nous vous répondons sous 48h ouvrables.",
      selectSector: "Sélectionnez un secteur", selectFormula: "Sélectionnez une formule",
    },
    booking: {
      title: "Prendre rendez-vous",
      subtitle: "Réservez un créneau, il s'enregistre automatiquement dans notre agenda.",
      date: "Date", time: "Heure", pickDate: "Choisissez une date",
      name: "Nom", email: "Email", phone: "Téléphone", sector: "Secteur", message: "Message (optionnel)",
      submit: "Confirmer le rendez-vous", submitting: "Confirmation...",
      success: "Rendez-vous confirmé ! Vous recevrez une confirmation.",
      noSlots: "Sélectionnez d'abord une date.", booked: "Réservé",
    },
    contact: {
      title: "Nous contacter", subtitle: "Notre équipe est à votre écoute du lundi au vendredi, 9h-18h.",
      office: "Bureau", gsm: "GSM", email: "Email", address: "Adresse",
      name: "Votre nom", msg: "Votre message", send: "Envoyer", sending: "Envoi...", success: "Message envoyé, merci !",
      notSure: "Notre IA n'est pas sûre ? Appelez-nous directement, nous répondons avec plaisir.",
    },
    ai: {
      title: "Assistant I-LEASE", online: "En ligne · IA",
      placeholder: "Posez votre question sur le leasing...",
      welcome: "Bonjour ! Je suis l'assistant IA d'I-LEASE. Posez-moi vos questions sur le leasing, le renting ou la LLD en Belgique. 🇧🇪",
      send: "Envoyer", thinking: "Réflexion...",
      disclaimer: "Recherche web en direct + Claude. En cas de doute, appelez le 067/87.05.53.",
    },
    footer: {
      tagline: "Courtier indépendant en leasing depuis 2015. Partout en Belgique.",
      company: "Société", legal: "Mentions légales", follow: "Nous suivre",
      warning: "Attention, emprunter de l'argent coûte aussi de l'argent.",
      warningBig: "EMPRUNTER DE L'ARGENT COÛTE AUSSI DE L'ARGENT !",
      rights: "Tous droits réservés.",
    },
    admin: {
      login: "Connexion", email: "Email", password: "Mot de passe", signin: "Se connecter", signingin: "Connexion...",
      space: "Espace personnel", logout: "Déconnexion",
      quotes: "Demandes d'offre", appointments: "Rendez-vous", contacts: "Messages", stats: "Statistiques",
      newq: "Nouvelles demandes", status: "Statut", date: "Date", actions: "Actions", download: "Télécharger",
    },
  },
  nl: {
    nav: { services: "Diensten", compare: "Vergelijking", faq: "FAQ", marketing: "AI Marketing", quote: "Offerte aanvragen", booking: "Afspraak", contact: "Contact", admin: "Mijn ruimte" },
    hero: {
      badge: "Sinds 2015 · Tevreden klanten",
      title1: "Slimme leasing",
      title2: "voor uw onderneming",
      subtitle: "Onafhankelijke makelaar in leasing, renting en langlopende verhuur. Auto's, vrachtwagens en civiele techniek — overal in België.",
      cta1: "Offerte aanvragen", cta2: "Praat met onze AI",
      stat1: "ervaring", stat1n: "10+ jaar", stat2: "antwoord", stat2n: "48u", stat3: "gedekt", stat3n: "België",
      warning: "Let op, geld lenen kost ook geld.",
    },
    sectors: {
      title: "Onze expertisesectoren", subtitle: "Een financieringsoplossing voor elke professional.",
      auto: { t: "Auto", d: "Bedrijfswagens, taxi, HORECA-sector. De beste voorwaarden op de markt." },
      truck: { t: "Vrachtwagens & Transport", d: "Zware voertuigen en wegtransport. Financiering op maat voor uw vloot." },
      civil: { t: "Civiele techniek", d: "Machines en bouwmaterieel. Rust uw bedrijf uit zonder uw kasstroom te blokkeren." },
    },
    compare: {
      title: "Leasing, Renting of LLD?", subtitle: "Begrijp de belangrijkste verschillen voor België.",
      col: { crit: "Criterium", leasing: "Leasing", renting: "Renting", lld: "LLD" },
      rows: { reg: "Inschrijving", balance: "Balans", residual: "Restwaarde", end: "Einde contract", owner: "Eigendom" },
      vals: {
        regL: "Op naam KLANT", regR: "Op naam KLANT", regLLD: "Op naam LEASEGEVER",
        balL: "Op balans (afgeschreven)", balR: "Buiten balans (kosten)", balLLD: "Buiten balans (kosten)",
        resL: "1% tot 15% (laag)", resR: "16% tot 25%", resLLD: "Geen aankoopoptie",
        endL: "Aankoop van het voertuig", endR: "Teruggave of aankoop", endLLD: "Teruggave voertuig",
        ownL: "Economisch eigenaar", ownR: "Leasegever blijft eigenaar", ownLLD: "Verhuurder blijft eigenaar",
      },
      note: "Samengevat: leasing en renting worden op naam van de klant ingeschreven (leasing op balans, renting buiten balans); LLD staat op naam van de leasegever en blijft buiten balans.",
    },
    faq: { title: "Veelgestelde vragen", subtitle: "Alles over leasing in België." },
    process: {
      title: "Hoe werkt het?", subtitle: "Antwoord binnen 48 werkuren zodra uw dossier compleet is.",
      steps: [
        { t: "1. Uw documenten", d: "Scan uw bestelbon, uw identiteitskaart voor/achter en uw laatste aanslagbiljet." },
        { t: "2. Uw restwaarde", d: "Kies uw restwaarde (van 1% tot 20%) die het aankoopbedrag op het einde bepaalt." },
        { t: "3. Veilig verzenden", d: "Stuur uw documenten via ons beveiligd GDPR-conform formulier of per e-mail." },
        { t: "4. Antwoord in 48u", d: "Ons dynamisch team antwoordt binnen 48 werkuren." },
      ],
    },
    marketing: {
      title: "AI Marketing", subtitle: "Genereer Facebook- & LinkedIn-postvoorstellen met één klik.",
      platform: "Platform", topic: "Onderwerp", topicPh: "Bv: voordelen van elektrische leasing in 2026",
      tone: "Toon", generate: "Voorstellen genereren", generating: "Genereren...", copy: "Kopiëren", copied: "Gekopieerd!",
      empty: "Kies een platform en onderwerp, genereer daarna 3 publicatieklare voorstellen.",
    },
    quote: {
      title: "Offerte aanvragen", subtitle: "Ontvang een persoonlijk antwoord binnen 48 werkuren.",
      name: "Volledige naam", email: "E-mail", phone: "Telefoon", company: "Bedrijf",
      sector: "Sector", formula: "Gewenste formule", vehicle: "Te financieren goed", vehiclePh: "Bv: Audi A4, Volvo truck, graafmachine...",
      message: "Bericht", docs: "Documenten (identiteitskaart, loonfiches, bestelbon)",
      upload: "Klik om bestanden toe te voegen (PDF, JPG, PNG)", uploading: "Verzenden...",
      gdpr: "Ik ga ermee akkoord dat I-LEASE SRL mijn persoonsgegevens en financiële documenten (identiteitskaart, loonfiches) verwerkt in het kader van mijn aanvraag, conform de GDPR.",
      submit: "Aanvraag verzenden", submitting: "Verzenden...",
      success: "Aanvraag verzonden! We antwoorden binnen 48 werkuren.",
      selectSector: "Selecteer een sector", selectFormula: "Selecteer een formule",
    },
    booking: {
      title: "Afspraak maken", subtitle: "Reserveer een tijdslot, het wordt automatisch in onze agenda opgeslagen.",
      date: "Datum", time: "Uur", pickDate: "Kies een datum",
      name: "Naam", email: "E-mail", phone: "Telefoon", sector: "Sector", message: "Bericht (optioneel)",
      submit: "Afspraak bevestigen", submitting: "Bevestigen...",
      success: "Afspraak bevestigd! U ontvangt een bevestiging.",
      noSlots: "Selecteer eerst een datum.", booked: "Gereserveerd",
    },
    contact: {
      title: "Contacteer ons", subtitle: "Ons team staat voor u klaar van maandag tot vrijdag, 9u-18u.",
      office: "Kantoor", gsm: "GSM", email: "E-mail", address: "Adres",
      name: "Uw naam", msg: "Uw bericht", send: "Verzenden", sending: "Verzenden...", success: "Bericht verzonden, bedankt!",
      notSure: "Twijfelt onze AI? Bel ons rechtstreeks, we helpen u graag.",
    },
    ai: {
      title: "I-LEASE Assistent", online: "Online · AI",
      placeholder: "Stel uw vraag over leasing...",
      welcome: "Hallo! Ik ben de AI-assistent van I-LEASE. Stel me uw vragen over leasing, renting of LLD in België. 🇧🇪",
      send: "Verzenden", thinking: "Nadenken...",
      disclaimer: "Live webzoekopdracht + Claude. Bij twijfel, bel 067/87.05.53.",
    },
    footer: {
      tagline: "Onafhankelijke leasingmakelaar sinds 2015. Overal in België.",
      company: "Bedrijf", legal: "Juridisch", follow: "Volg ons",
      warning: "Let op, geld lenen kost ook geld.", warningBig: "GELD LENEN KOST OOK GELD !", rights: "Alle rechten voorbehouden.",
    },
    admin: {
      login: "Inloggen", email: "E-mail", password: "Wachtwoord", signin: "Inloggen", signingin: "Inloggen...",
      space: "Persoonlijke ruimte", logout: "Uitloggen",
      quotes: "Offerteaanvragen", appointments: "Afspraken", contacts: "Berichten", stats: "Statistieken",
      newq: "Nieuwe aanvragen", status: "Status", date: "Datum", actions: "Acties", download: "Downloaden",
    },
  },
  en: {
    nav: { services: "Services", compare: "Compare", faq: "FAQ", marketing: "AI Marketing", quote: "Get a quote", booking: "Book", contact: "Contact", admin: "My space" },
    hero: {
      badge: "Since 2015 · Delighted clients",
      title1: "Smart leasing",
      title2: "for your business",
      subtitle: "Independent broker in leasing, renting and long-term rental. Cars, trucks and civil engineering — all across Belgium.",
      cta1: "Request a quote", cta2: "Chat with our AI",
      stat1: "of experience", stat1n: "10+ years", stat2: "response", stat2n: "48h", stat3: "covered", stat3n: "Belgium",
      warning: "Warning, borrowing money also costs money.",
    },
    sectors: {
      title: "Our areas of expertise", subtitle: "A financing solution tailored to every professional.",
      auto: { t: "Automobile", d: "Company cars, taxi, HORECA sector. The best conditions on the market." },
      truck: { t: "Trucks & Transport", d: "Heavy vehicles and road transport. Tailor-made financing for your fleet." },
      civil: { t: "Civil engineering", d: "Machines and construction equipment. Equip your company without tying up cash." },
    },
    compare: {
      title: "Leasing, Renting or LTR?", subtitle: "Understand the key differences for Belgium.",
      col: { crit: "Criterion", leasing: "Leasing", renting: "Renting", lld: "LTR" },
      rows: { reg: "Registration", balance: "Balance sheet", residual: "Residual value", end: "End of contract", owner: "Ownership" },
      vals: {
        regL: "In CLIENT's name", regR: "In CLIENT's name", regLLD: "In LESSOR's name",
        balL: "On balance (amortised)", balR: "Off balance (expenses)", balLLD: "Off balance (expenses)",
        resL: "1% to 15% (low)", resR: "16% to 25%", resLLD: "No purchase option",
        endL: "Buy back the vehicle", endR: "Return or buy back", endLLD: "Return the vehicle",
        ownL: "Economic owner", ownR: "Lessor stays owner", ownLLD: "Lessor stays owner",
      },
      note: "In short: leasing and renting are registered in the client's name (leasing on balance, renting off balance); LTR is registered in the lessor's name and stays off balance.",
    },
    faq: { title: "Frequently asked questions", subtitle: "Everything about leasing in Belgium." },
    process: {
      title: "How it works", subtitle: "An answer within 48 working hours once your file is complete.",
      steps: [
        { t: "1. Your documents", d: "Scan your purchase order, your ID card front/back and your latest tax assessment." },
        { t: "2. Your residual value", d: "Choose your residual value (1% to 20%) which sets the buy-back amount at the end." },
        { t: "3. Secure upload", d: "Send your documents via our secure GDPR-compliant form or by email." },
        { t: "4. Answer in 48h", d: "Our dynamic team replies within 48 working hours." },
      ],
    },
    marketing: {
      title: "AI Marketing", subtitle: "Generate Facebook & LinkedIn post proposals in one click.",
      platform: "Platform", topic: "Post topic", topicPh: "e.g. benefits of electric leasing in 2026",
      tone: "Tone", generate: "Generate proposals", generating: "Generating...", copy: "Copy", copied: "Copied!",
      empty: "Pick a platform and a topic, then generate 3 ready-to-publish proposals.",
    },
    quote: {
      title: "Request a quote", subtitle: "Get a personalised answer within 48 working hours.",
      name: "Full name", email: "Email", phone: "Phone", company: "Company",
      sector: "Sector", formula: "Desired formula", vehicle: "Asset to finance", vehiclePh: "e.g. Audi A4, Volvo truck, excavator...",
      message: "Message", docs: "Documents (ID card, salary slips, purchase order)",
      upload: "Click to add files (PDF, JPG, PNG)", uploading: "Uploading...",
      gdpr: "I agree that I-LEASE SRL processes my personal data and financial documents (ID card, salary slips) as part of my request, in accordance with GDPR.",
      submit: "Send my request", submitting: "Sending...",
      success: "Request sent! We reply within 48 working hours.",
      selectSector: "Select a sector", selectFormula: "Select a formula",
    },
    booking: {
      title: "Book an appointment", subtitle: "Reserve a slot, it saves automatically to our calendar.",
      date: "Date", time: "Time", pickDate: "Pick a date",
      name: "Name", email: "Email", phone: "Phone", sector: "Sector", message: "Message (optional)",
      submit: "Confirm appointment", submitting: "Confirming...",
      success: "Appointment confirmed! You will receive a confirmation.",
      noSlots: "Select a date first.", booked: "Booked",
    },
    contact: {
      title: "Contact us", subtitle: "Our team is available Monday to Friday, 9am-6pm.",
      office: "Office", gsm: "Mobile", email: "Email", address: "Address",
      name: "Your name", msg: "Your message", send: "Send", sending: "Sending...", success: "Message sent, thank you!",
      notSure: "AI not sure? Call us directly, we're happy to help.",
    },
    ai: {
      title: "I-LEASE Assistant", online: "Online · AI",
      placeholder: "Ask your leasing question...",
      welcome: "Hi! I'm I-LEASE's AI assistant. Ask me about leasing, renting or LTR in Belgium. 🇧🇪",
      send: "Send", thinking: "Thinking...",
      disclaimer: "Live web search + Claude. When in doubt, call 067/87.05.53.",
    },
    footer: {
      tagline: "Independent leasing broker since 2015. All across Belgium.",
      company: "Company", legal: "Legal", follow: "Follow us",
      warning: "Warning, borrowing money also costs money.", warningBig: "BORROWING MONEY ALSO COSTS MONEY !", rights: "All rights reserved.",
    },
    admin: {
      login: "Login", email: "Email", password: "Password", signin: "Sign in", signingin: "Signing in...",
      space: "Personal space", logout: "Logout",
      quotes: "Quote requests", appointments: "Appointments", contacts: "Messages", stats: "Statistics",
      newq: "New requests", status: "Status", date: "Date", actions: "Actions", download: "Download",
    },
  },
};

export const faqData = {
  fr: [
    { q: "Quelle est la différence entre leasing, renting et LLD ?", a: "Le leasing est immatriculé au nom du client et figure au bilan (valeur résiduelle faible, 1% à 15%). Le renting est également immatriculé au nom du client mais reste hors bilan, avec une valeur résiduelle de 16% à 25%. La location longue durée (LLD) est immatriculée au nom du leaseur, reste hors bilan et n'a généralement pas d'option d'achat." },
    { q: "Au nom de qui la voiture est-elle immatriculée ?", a: "En leasing financier ET en renting, le véhicule est immatriculé au nom du CLIENT. En LLD (location longue durée), il est immatriculé au nom du LEASEUR (la société de leasing)." },
    { q: "Qu'est-ce que la valeur résiduelle ?", a: "C'est le montant de rachat de votre bien en fin de contrat. Vous la choisissez au préalable : de 1% à 15% en leasing (faible), de 16% à 25% en renting. Elle influence directement le montant de vos loyers." },
    { q: "Le leasing apparaît-il à mon bilan ?", a: "Oui. Le leasing financier apparaît en amortissement au bilan de votre société. Le renting et la LLD apparaissent sous forme de charges et restent hors bilan : vous ne mobilisez pas vos lignes de crédit." },
    { q: "Dois-je préfinancer la TVA ?", a: "Non. En leasing comme en renting, il n'y a pas de préfinancement de la TVA. La TVA suit les échéances/loyers." },
    { q: "Quels documents dois-je fournir ?", a: "Votre bon de commande ou offre, votre carte d'identité recto/verso, et votre dernier avertissement extrait de rôle. Des fiches de salaire peuvent être demandées. Vous pouvez tout envoyer via notre formulaire sécurisé (RGPD)." },
    { q: "Combien de temps pour obtenir une réponse ?", a: "I-LEASE s'engage à vous fournir une réponse endéans les 48 heures ouvrables, dès que votre dossier est complet." },
    { q: "Financez-vous les camions et le matériel de génie civil ?", a: "Oui. Au-delà de l'automobile, nous finançons les camions, le transport routier ainsi que les machines et engins de génie civil, partout en Belgique." },
    { q: "Puis-je financer en tant qu'indépendant ?", a: "Oui. Nous avons une solution adaptée pour chaque indépendant et chaque société. Contactez-nous pour étudier votre projet." },
  ],
  nl: [
    { q: "Wat is het verschil tussen leasing, renting en LLD?", a: "Leasing wordt op naam van de klant ingeschreven en staat op de balans (lage restwaarde, 1% tot 15%). Renting wordt eveneens op naam van de klant ingeschreven maar blijft buiten balans, met een restwaarde van 16% tot 25%. Langlopende verhuur (LLD) staat op naam van de leasegever, blijft buiten balans en heeft doorgaans geen aankoopoptie." },
    { q: "Op wiens naam wordt de wagen ingeschreven?", a: "Bij financiële leasing ÉN bij renting op naam van de KLANT. Bij LLD (langlopende verhuur) op naam van de LEASEGEVER (de leasingmaatschappij)." },
    { q: "Wat is de restwaarde?", a: "Het aankoopbedrag van uw goed op het einde van het contract. U kiest het vooraf: 1% tot 15% bij leasing (laag), 16% tot 25% bij renting. Het beïnvloedt rechtstreeks uw huurbedragen." },
    { q: "Staat leasing op mijn balans?", a: "Ja. Financiële leasing staat als afschrijving op de balans. Renting en LLD verschijnen als kosten en blijven buiten balans: uw kredietlijnen blijven vrij." },
    { q: "Moet ik de btw voorfinancieren?", a: "Nee. Bij zowel leasing als renting is er geen btw-voorfinanciering." },
    { q: "Welke documenten moet ik bezorgen?", a: "Uw bestelbon of offerte, uw identiteitskaart voor/achter en uw laatste aanslagbiljet. Loonfiches kunnen gevraagd worden. U kunt alles via ons beveiligd formulier (GDPR) versturen." },
    { q: "Hoelang duurt het om een antwoord te krijgen?", a: "I-LEASE engageert zich om binnen 48 werkuren te antwoorden zodra uw dossier compleet is." },
    { q: "Financieren jullie vrachtwagens en civiel materieel?", a: "Ja. Naast auto's financieren wij vrachtwagens, wegtransport en machines voor civiele techniek, overal in België." },
    { q: "Kan ik als zelfstandige financieren?", a: "Ja. Wij hebben een oplossing voor elke zelfstandige en elk bedrijf. Contacteer ons voor uw project." },
  ],
  en: [
    { q: "What is the difference between leasing, renting and LTR?", a: "Leasing is registered in the client's name and appears on the balance sheet (low residual value, 1% to 15%). Renting is also registered in the client's name but stays off balance, with a residual value of 16% to 25%. Long-term rental (LTR) is registered in the lessor's name, stays off balance and usually has no purchase option." },
    { q: "In whose name is the car registered?", a: "In financial leasing AND in renting, the vehicle is registered in the CLIENT's name. In LTR (long-term rental), it is registered in the LESSOR's name (the leasing company)." },
    { q: "What is the residual value?", a: "It is the buy-back amount of your asset at the end of the contract. You choose it upfront: 1% to 15% in leasing (low), 16% to 25% in renting. It directly influences your monthly rents." },
    { q: "Does leasing appear on my balance sheet?", a: "Yes. Financial leasing appears as depreciation on your balance sheet. Renting and LTR appear as expenses and stay off balance: your credit lines remain free." },
    { q: "Do I have to pre-finance VAT?", a: "No. In both leasing and renting there is no VAT pre-financing. VAT follows the instalments/rents." },
    { q: "What documents do I need to provide?", a: "Your purchase order or offer, your ID card front/back, and your latest tax assessment. Salary slips may be requested. You can send everything via our secure GDPR form." },
    { q: "How long to get an answer?", a: "I-LEASE commits to a reply within 48 working hours once your file is complete." },
    { q: "Do you finance trucks and civil engineering equipment?", a: "Yes. Beyond automobiles, we finance trucks, road transport and civil engineering machines and equipment, all across Belgium." },
    { q: "Can I finance as a self-employed person?", a: "Yes. We have a solution for every self-employed person and company. Contact us to study your project." },
  ],
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("ilease_lang") || "fr");
  const change = (l) => { setLang(l); localStorage.setItem("ilease_lang", l); };
  const t = translations[lang];
  return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
